import { createFileRoute } from "@tanstack/react-router";
import { CollectionsIndex, collectionsIndexLoader, collectionsIndexHeadDa } from "@/pages/CollectionsIndex";

export const Route = createFileRoute("/collections/")({
  loader: collectionsIndexLoader,
  head: collectionsIndexHeadDa,
  component: CollectionsIndex,
});
